import { useState, useEffect } from "react";
import { useLanguages } from "/api/user/language-change";
import i18n from "/i18n/i18n";
import { getUnifiedLanguageCode } from "/utils/extractBrowserLanguage";

/**
 * @returns {{ detectedLanguage: {
 * uuid: string,
 * alpha2Code: string,
 * isDefault: boolean,
 * } | null }}
 */
export function useDetectLanguage() {
  const { data: languages } = useLanguages();
  const [detectedLanguage, setDetectedLanguage] = useState(null);

  useEffect(() => {
    const browserLang = getUnifiedLanguageCode(i18n.language);
    const list = Array.isArray(languages) ? languages : [];

    if (!list.length) {
      setDetectedLanguage(null);
      return;
    }

    const byCode = list.find((lang) => lang.alpha2Code === browserLang);
    if (byCode) {
      setDetectedLanguage(byCode);
      return;
    }

    const byDefault = list.find((lang) => lang.isDefault);
    setDetectedLanguage(byDefault || null);
  }, [languages]);

  return {
    detectedLanguage,
  };
}
